import { Controller } from '@hotwired/stimulus';

/**
 * Stimulus controller for handling inline statement creation from invoice modals
 *
 * This controller handles the Turbo Stream response after creating a statement
 * inline from the invoice preview modal.
 */
export default class extends Controller {
  static values = {
    modalId: String,
  };

  connect() {
    // Listen for turbo:submit-end to handle the response
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this));
  }

  handleSubmitEnd(event) {
    const { success } = event.detail;

    if (success) {
      // Hide reject button immediately after successful statement creation
      if (this.hasModalIdValue) {
        const modal = document.getElementById(this.modalIdValue);
        if (modal) {
          const rejectButton = modal.querySelector('[aria-label="Rejeter la facture"]');
          if (rejectButton) {
            rejectButton.style.display = 'none';
          }
        }
      }
      // Modal stays open - user can manually close or navigate to next invoice
    }
  }
}
